import { images } from "../../../images/image-list-content";

export const getImageListContent = () => {
	return images;
};
